import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ROUTES from "../constants/routes";
import AuthLoading from "../components/auth/AuthLoading";

const skipAuth = process.env.REACT_APP_SKIP_AUTH === "true";

export default function ProtectedRoute({ children }) {
  const { isLoggedIn, loading } = useAuth();

  if (skipAuth) {
    return children;
  }

  if (loading) {
    return <AuthLoading />;
  }

  if (!isLoggedIn) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return children;
}
